





















































import { Vue, Component } from "vue-property-decorator"
import BackgroundImage from "@/components/BackgroundImage.vue"
import { api } from "../../api"
import { AxiosError } from "axios"
import { UNPROCESSABLE_ENTITY } from "http-status-codes"
import { store } from "../../../store"
import { startDemoPlay } from "../demo_play"
import { Route } from "vue-router"
import { i18nTranslate } from "@/i18n"

let mountCount = 0

@Component({
  components: { BackgroundImage },
})
export default class extends Vue {
  email = ""
  password = ""
  mountCount = mountCount

  mounted() {
    ;(this.$refs.id as any).focus()
    store.currentFrame.modules.sspData.activeReruns = ["pdr2_wide", "pdr2_dud"]
    this.mountCount = ++mountCount
  }

  get inquiryLink() {
    return i18nTranslate({
      en: "https://forms.office.com/Pages/ResponsePage.aspx?id=3sqHADRb2kSC3zViN2lm-cuakBnBwtdPlku4Tux1abJUNEdIMDNVOTNJMjk2WTJXOU41UFpNWVQ1RCQlQCN0PWcu",
      ja: "https://forms.office.com/Pages/ResponsePage.aspx?id=3sqHADRb2kSC3zViN2lm-cuakBnBwtdPlku4Tux1abJUNlM0OVZBWUw0TExGV1BSMk9MTjdZRVBJTiQlQCN0PWcu",
    })
  }

  async submit() {
    const { email, password } = this

    const axios = api.passErrors(UNPROCESSABLE_ENTITY)
    try {
      const res = await axios.post("../api/v1/session", { email, password })
      const next =
        typeof this.$route.query.next === "string"
          ? this.$route.query.next
          : "/"
      this.$router.push(next)
      if (next === "/") {
        await store
          .currentGlobe()
          .viewFactory.jumpTo({ theta: 0, phi: 0, fovy: 1 }, { duration: 2000 })
          .promise
      }
    } catch (e) {
      const error: AxiosError = e
      switch (error.response!.status) {
        case UNPROCESSABLE_ENTITY:
          alert(this.$t("unauthorized"))
          break
      }
    }
  }

  static beforeEnter(to: Route, from: Route, next: () => void) {
    startDemoPlay()
    next()
  }
}
